import { faHouse, faFileLines, faUsers, faSun, faSterlingSign, faShieldHalved, faComments, faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getSaiTerminology } from '../config/terminology'
import { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';

import useAuth from '../hooks/useAuth'

import InviteMeetingModal from './Admin/SAI/Components/InviteMeetingModal'
import ReferralModal from './Admin/SAI/Components/ReferralModal'

const SideBar = ({ active, onNavigate }) => {
  const { auth } = useAuth()
  
  const [policyData, setPolicyData] = useState(null)

  const terms = getSaiTerminology(policyData)

  const [openInvite, setOpenInvite] = useState(false)
  const [openReferral, setOpenReferral] = useState(false)
  const [showThanks, setShowThanks] = useState(false)

  useEffect(() => {
    setPolicyData(JSON.parse(localStorage.getItem('policyData')))
  }, []);

  const policyStaff = policyData?.policy_staff ? JSON.parse(policyData.policy_staff) : {};
  const policyHoliday = policyData?.policy_holiday ? JSON.parse(policyData.policy_holiday) : {};

  const claimsDisabled = (policyStaff?.status === 'draft' ||
    policyHoliday?.status === 'draft' ||
    policyData?.policy_payment_type === 'Not Supplied')

  const navItems = [
    { label: 'Dashboard', icon: faHouse, path: '/sai/dashboard' },
    { label: terms.claim.pluralTitle, icon: faFileLines, path: '/sai/claims', disabled: claimsDisabled },
    { label: 'Staff Details', icon: faUsers, path: '/sai/staff-details' },
    { label: 'Holidays', icon: faSun, path: '/sai/holidays' },
    { label: 'Accounts', icon: faSterlingSign, path: '/sai/accounts' },
    { label: 'Policy Information', icon: faShieldHalved, path: '/sai/policy-information' },
  ];

  const bottomItems = [
    // { label: `${terms.policy.singularTitle} Information`, icon: faShieldHalved, path: '/sai/policy-information' },
    // { label: 'Message Centre', icon: faComments, path: '/sai/messages' },
    // { label: `FAQ's`, icon: faQuestionCircle, path: 'https://schools-advisory-service.tawk.help', external: true },
  ]

  const openReferralModal = () => {
    setOpenReferral(true)
    setShowThanks(true)
  }

  const openInviteModal = () => {
    setOpenInvite(true)
    setShowThanks(true)
  }

  const handleClick = (e, item) => {
    const { path, disabled, external } = item

    if (disabled) {
      e.preventDefault()
      return
    }

    if (external) {
      if (onNavigate) {
        e.preventDefault()
        onNavigate(path, { external: true })
      }
      return
    }

    if (onNavigate) {
      e.preventDefault()
      onNavigate(path)
    }
  };

  return (
    <aside className="bg-white rounded-xl shadow-md p-6 w-full lg:w-1/5 max-h-[calc(100vh-4rem)] overflow-y-auto">
      <nav className="space-y-2 text-sas-dark font-semibold">
        {navItems.map((item) => (
          <NavLink
            key={item.label}
            to={item.path}
            className={({ isActive }) =>
              `w-full px-4 py-2 rounded-md flex items-center transition-all ${item.disabled
                ? 'opacity-50 cursor-not-allowed'
                : isActive
                  ? 'bg-sas text-white'
                  : 'text-sas-dark hover:bg-sas-light hover:text-sas'
              }`
            }
            aria-disabled={item.disabled ? 'true' : 'false'}
            onClick={(e) => handleClick(e, item)}
          >
            <FontAwesomeIcon icon={item.icon} fixedWidth />
            <span className="ml-3">{item.label}</span>
          </NavLink>
        ))}

        <div className="border-t my-4" />

        <button
          onClick={openReferralModal}
          className="w-full text-sm text-center block px-4 py-2 rounded-md bg-green-100 text-green-800 border border-green-200 font-semibold hover:bg-green-200"
        >
          Refer a School
        </button>

        <button
          onClick={openInviteModal}
          className="w-full text-sm text-center block px-4 py-2 rounded-md bg-green-100 text-green-800 border border-green-200 font-semibold hover:bg-green-200"
        >
          Invite us to your meeting
        </button>

        {/* <div className="border-t my-4" /> */}

        {/* {bottomItems.map((item) => (
          <NavLink
            key={item.label}
            to={item.path}
            className={({ isActive }) =>
              `w-full flex px-4 py-2 rounded-md items-center transition-all ${isActive
                ? 'bg-sas text-white'
                : 'text-sas-dark hover:bg-sas-light hover:text-sas'
              }`
            }
            target={item.external ? '_blank' : undefined}
            rel={item.external ? 'noopener noreferrer' : undefined}
            onClick={(e) => handleClick(e, item)}
          >
            <FontAwesomeIcon icon={item.icon} />
            <span className="ml-3">{item.label}</span>
          </NavLink>
        ))} */}
      </nav>

      <InviteMeetingModal openInvite={openInvite} setOpenInvite={setOpenInvite} />
      <ReferralModal openReferral={openReferral} setOpenReferral={setOpenReferral} />
    </aside>
  )
}

export default SideBar

